import { FC, ReactNode } from 'react';
import styles from './index.module.scss';

interface EmptyTableProps {
  tableTitle?: string | ReactNode;
  emptyMessage: string;
}

export const EmptyTable: FC<EmptyTableProps> = ({ tableTitle, emptyMessage }) => {
  return (
    <div className={styles.tableWrapper}>
      {tableTitle && <div className={styles.tableTitle}>{tableTitle}</div>}
      <div className={styles.tableEmpty} role='alert'>
        {emptyMessage}
      </div>
    </div>
  );
};
